export const totalPrice = (ptPrice: number, areas: PrintAreaPrice[]) =>
  ptPrice +
  areas.reduce(
    (areaSum, area) =>
      areaSum +
      area.printing +
      area.configurations.reduce(
        (configurationsSum, configuration) => configurationsSum + configuration.price,
        0
      ),
    0
  );
